import { notification } from 'antd';
import { appApi } from 'services/api/api-instance';
import type { ListResponseWithPagination } from 'services/api/types';
import type {
  CreateBuildingBody,
  Building,
  BuildingListRequest,
  UpdateBuildingBody,
} from './types';

export const getBuildingList = (
  params: BuildingListRequest = {},
): Promise<ListResponseWithPagination<Building>> => {
  return appApi
    .get('/buildings/with-room-count', {
      params,
      paramsSerializer: { indexes: null },
    })
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить здания' });
      throw error;
    });
};

export const getBuildings = (): Promise<ListResponseWithPagination<Building>> => {
  return appApi
    .get('/buildings/with-room-count')
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить здания' });
      throw error;
    });
};

export const getBuildingById = (buildingId: number): Promise<Building> => {
  return appApi
    .get(`/buildings/${buildingId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить здание' });
      throw error;
    });
};

export const createBuilding = (body: CreateBuildingBody): Promise<Building> => {
  return appApi
    .post('/buildings', body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось создать здание' });
      throw error;
    });
};

export const removeBuilding = (buildingId: number): Promise<void> => {
  return appApi
    .delete(`/buildings/${buildingId}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось удалить здание' });
      throw error;
    });
};

export const updateBuilding = (buildingId: number, body: UpdateBuildingBody): Promise<Building> => {
  return appApi
    .put(`/buildings/${buildingId}`, body)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить здание' });
      throw error;
    });
};
